import { render } from "./PostReport.vue?vue&type=template&id=52817bc2&scoped=true"
import script from "./PostReport.vue?vue&type=script&lang=js"
export * from "./PostReport.vue?vue&type=script&lang=js"

import "./PostReport.vue?vue&type=style&index=0&id=52817bc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52817bc2"]])

export default __exports__